module.exports = __webpack_public_path__ + "assets/img/8a53eeba051513f7e2e0c27ecd18fa3e.png";